// extracted by mini-css-extract-plugin
export default {"customer":"jBBFN","customer-name":"Y-oOe","customerName":"Y-oOe"};